import { FullScreen } from "@single-js/common/components/fullscreen/fullscreen";
import BANNER_LOGO from "assets/images/banner-logo.svg";
import * as React from "react";
import InternalLink from "view/common/internal-link";
import "./wrapper.scss";
// This component is wrapped around some of the /connect pages, namely the
// clusters list page and the connect-to-cluster page.
export default function ConnectWrapper({ children }) {
    const logo = React.createElement("img", { src: BANNER_LOGO, alt: "SingleStore Studio" });
    // When `window.ROOT_REDIRECT` is defined, the top banner logo points to
    // that instead of the home page (which doesn't exist).
    let logoWrapper;
    if (window.ROOT_REDIRECT) {
        logoWrapper = React.createElement("a", { href: window.ROOT_REDIRECT }, logo);
    }
    else {
        logoWrapper = (React.createElement(InternalLink, { routeInfo: { name: "connect" }, category: "connect" }, logo));
    }
    return (React.createElement(FullScreen, { className: "connect-wrapper", fullWidth: true },
        React.createElement("div", { className: "banner" }, logoWrapper),
        React.createElement("div", { className: "children-container" }, children)));
}
